/**
 * Config
 * Location Autocomplete
 * @author Rhys Lloyd
 */

import {COMPONENT_RESTRICTIONS} from '../../services/geolocation/config';


//noinspection JSValidateTypes
/**
 * @type {google.maps.AutocompleteOptions}
 */
export const AUTOCOMPLETE_OPTIONS = {
	types: ['(regions)'],
	componentRestrictions: COMPONENT_RESTRICTIONS,
};

/**
 *
 * @type {string}
 */
export const AUTOCOMPLETE_INPUT_DATA_ATTRIBUTE = 'data-location-autocomplete';

/**
 * Selector used to indicate which fields have autocomplete bound to them.
 * @type {string}
 */
export const AUTOCOMPLETE_INPUT_SELECTOR = `[${AUTOCOMPLETE_INPUT_DATA_ATTRIBUTE}]`;

/**
 * @type {string}
 */
export const AUTOCOMPLETE_SYNC_KEY = 'sync';

/**
 * @type {string}
 */
export const LOCATION_FIELD_CONTEXT = 'location-field-context';

/**
 * @type {string}
 */
export const LOCATION_FIELD_SELECTED_PLACE = 'location-field-selected-place';



// WEBPACK FOOTER //
// ./project/client/src/core/modules/location-autocomplete/config.js